import {createScrollInstances, ScrollUI} from './scrollUI';

export class Scroll {

    public constructor(private ui: ScrollUI) {
        this.ui.onNavClick(this.scrollToContent.bind(this))
    }

    public scrollToContent(ID: string) {

        const el = this.ui.getAnchorElement(ID);

        const position = this.ui.getOffset(el) - 130;

        this.ui.smoothScroll(position);
    }
}


export function initScroll() {
    const uiInstance = createScrollInstances();
    const instance = uiInstance.map((uiInstance: ScrollUI) => {
        return new Scroll(uiInstance);
    });
}
